module.exports = __webpack_public_path__ + "static/media/Question3_C_HL.91ecc9bd.png";